module.exports = __webpack_public_path__ + "img/solowin-logo.1b021864.png";